export const orderRef = (orderOrRef) => {
  if (!orderOrRef) return "";

  if (typeof orderOrRef === "string" || typeof orderOrRef === "number") {
    return String(orderOrRef);
  }

  return String(orderOrRef.public_id || orderOrRef.order_ref || orderOrRef.id || "");
};

export const orderDetailUrl = (orderOrRef) => {
  const ref = orderRef(orderOrRef);

  return ref ? `/orders/detail/${ref}` : "/orders";
};

export const orderSuccessUrl = (orderOrRef) => {
  const ref = orderRef(orderOrRef);

  return ref ? `/order-success/${ref}` : "/orders";
};
